import React, { createContext, useContext } from 'react';

// Language configuration with assistant IDs and translations.
const languageConfig = {
  de: {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
    assistantId: '8f7bd8be-1b34-476e-86c5-74c8a660e066', // German assistant
    translations: {
      // Header
      headerTitle: 'Beyerdynamic bei MediaMarkt',
      headerSubtitle: 'Premium Audio-Erlebnis',

      // Main CTA
      mainCtaTitle: ['KOSTENLOSE', 'KOPFHÖRER', 'KI BERATUNG'],
      mainCtaSubtitle: 'Lassen Sie sich von unserem KI-Assistenten bei der Auswahl Ihres perfekten beyerdynamic Kopfhörers unterstützen – intelligent, individuell und abgestimmt auf Ihre persönlichen Anforderungen.',

      // Voice Button
      startConsultation: 'Jetzt Starten',
      endConsultation: 'Beratung beenden',
      connecting: 'Verbinde...',
      startButtonText: 'JETZT|STARTEN',
      stopButtonText: 'JETZT|STOPPEN',

      // Product Detail Modal
      aiRecommendations: 'KI EMPFEHLUNGEN',
      endCall: 'Beenden',
      learnMore: 'Erfahre mehr',
      topRecommendation: 'Top Empfehlung',
      alternative: 'Alternative',
      startCall: 'Starten',
      pauseCall: 'Pausieren',

      // Headphone Type Selector
      selectHeadphoneType: 'Wählen Sie Ihren Kopfhörer-Typ',
      speakYourChoice: 'Bitte sprechen Sie Ihre bevorzugte Auswahl'
    }
  }
};

// The only language the frontend runs in
const DEFAULT_LANGUAGE = 'de';

// Create Context
const LanguageContext = createContext();

// Provider Component
export const LanguageProvider = ({ children }) => {
  const currentLanguage = DEFAULT_LANGUAGE;

  const getCurrentConfig = () => languageConfig[currentLanguage];

  const translate = (key) => {
    const config = getCurrentConfig();
    return config.translations[key] || key;
  };

  // Pick the right language for a value that is either a plain string (legacy)
  // or a { de, en, pl } object. Falls back to German, then to any first value.
  const localize = (value) => {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      return value[currentLanguage] || value.de || value.en || Object.values(value)[0] || '';
    }
    return String(value);
  };

  const getAssistantId = () => {
    const config = getCurrentConfig();
    return config.assistantId;
  };

  const value = {
    currentLanguage,
    translate,
    localize,
    getAssistantId,
    getCurrentConfig
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom Hook
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;

